<div
  class="single-piece"
  [class.hover]="state === 'hover'"
  (click)="onActionClick($event)"
  [class.disable]="disabled">
  <div class="items-wrapper d-flex justify-content-between">
    <div class="d-flex spacing-8 align-items-center">
      @if (dragDrop) {
        <app-ce-icon
          name="drag_drop"
          [ngClass]="color"
          class="my-auto drag-drop-icon"></app-ce-icon>
      }
      @if (radio) {
        <app-radio
          [active]="false"
          label=""
          [disabled]="false"
          class="my-auto"
          [value]="value"
          (selected)="onRadioClick($event, value)"></app-radio>
      }
      @if (checkbox) {
        <app-checkbox
          [checked]="checked"
          (onCheckChange)="onCheckChange.emit($event)"
          class="my-auto"></app-checkbox>
      }
      @if (showUser) {
        <img class="ce-img" height="32" width="32" [ngSrc]="image" alt="" />
      }
      @if (icon) {
        <app-ce-icon [name]="iconType" [ngClass]="color" class="my-auto left-icon"></app-ce-icon>
      }
      @if (label) {
        <span class="label h3-{{ type }} my-auto" [innerText]="label" [ngClass]="color"></span>
      }
      @if (showBadge) {
        <app-badges
          [class.d-none]="!badgeLabel"
          [withIcon]="true"
          [Type]="badgeType"
          [counter]="false"
          [divideText]="'Order no.'"
          [dividedText]="false"
          [close]="false"
          [onlyIcon]="false"
          [label]="badgeLabel"
          [ellipsis]="true"></app-badges>
      }
    </div>
    <div class="d-flex spacing-8">
      @if (toggle) {
        <app-toggle
          [name]="id"
          [active]="value"
          [disabled]="false"
          [isHandleToggle]="false"
          size="medium"
          class="my-auto"></app-toggle>
      }
      @if (more) {
        <app-ce-icon
          class="my-auto"
          [name]="moreIcon"
          [svg_class]="['primary-50', 'cursor-pointer']"
          (click)="onActionClick($event)"></app-ce-icon>
      }
    </div>
  </div>
</div>
